import React from 'react'
import Footer from './Footer'

function Flag() {
    return (
        <div className='flag'>
            <div className="other_overlay"></div>
            <div className="flag_container">
                <h2>
                    Please Choose your Country Destination
                </h2>
                <div className="selections">
                    <select name="event" id="event">
                        <option value="wedding"> </option>
                        <option value="conference">AFGHANISTAN</option>
                        <option value="meetings">ALBANIA</option>
                        <option value="sport">ALGERIA</option>
                        <option value="sport">AMERICAN SAMOA</option> 
                        <option value="sport">ANDORRA</option>
                        <option value="sport">ANGOLA</option>
                        <option value="sport">ANTARCTICA</option>
                        <option value="sport">ANTIGUA AND BARBUDA</option>
                        <option value="sport">ARGENTINA</option>
                        <option value="sport">ARMENIA</option>
                        <option value="sport">ARUBA</option>
                    </select>
                </div>
            </div>

            <Footer />

        </div>
    )
}

export default Flag
